import styled from '@emotion/styled';
import {
  BLACK,
  BLACK_1,
  mq,
} from '@/features/theme';

export const ToolbarContainer = styled.div(() => {
  return {
    top: '0',
    right: '0',
    width: '100%',
    maxWidth: '648px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '24px',
    zIndex: '10',

    [mq.sm]: { padding: '16px' },
  };
});

export const NavigationGroup = styled.div(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: '12px',
    height: '100%',
  };
});

export const ActionsGroup = styled.div(() => {
  return {
    display: 'flex',
    alignItems: 'stretch',
    gap: '4px',
    marginLeft: 'auto',
    height: '100%',
  };
});

export const ToolbarButton = styled.button(() => {
  return {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    marginLeft: 'auto',
    padding: '6px 12px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: 'rgba(10, 11, 11, 0.05)',
    transition: 'background-color 0.1s ease-in-out',
    cursor: 'pointer',
    color: BLACK,

    ':hover': { backgroundColor: BLACK_1 },
  };
});

export const ToolbarButtonText = styled.div(() => {
  return {
    fontSize: '14px',
    fontWeight: '600',

    [mq.sm]: { display: 'none' },
  };
});
